export const notCandidateColumns = ['phones', 'emails'];
export const notOrderColumns = ['orderId', 'brand', 'division', 'facility', 'unit'];
export const notFacilityColumns = ['brand', 'facility'];
